const childRoutes = (prop) => [
  {
    path: 'sales-dashboard',
    name: prop + '.sales_dashboard',
    meta: { auth: true },
    component: () => import('../pages/sales-dashboard/List.vue')
  },
  {
    path: 'sales-target',
    name: prop + '.sales_target',
    meta: { auth: true },
    component: () => import('../pages/sales-target/List.vue')
  },
  {
    path: 'sales-target-entry',
    name: prop + '.sales_target_entry',
    meta: { auth: true },
    component: () => import('../pages/sales-target/Form.vue')
  },
  {
    path: 'delivery-orders',
    name: prop + '.delivery_orders',
    meta: { auth: true },
    component: () => import('../pages/delivery-orders/List.vue')
  },
  {
    path: 'delivery-orders-entry',
    name: prop + '.delivery_orders_entry',
    meta: { auth: true },
    component: () => import('../pages/delivery-orders/Form.vue')
  },
  {
    path: 'delivery-order-receive',
    name: prop + '.delivery_order_receive',
    meta: { auth: true },
    component: () => import('../pages/delivery-order-receive/List.vue')
  },
  {
    path: 'dealer-retailer-details-report',
    name: prop + '.dealer_retailer_details_report',
    meta: { auth: true },
    component: () => import('../pages/dealer-retailer-details-report/List.vue')
  },
  {
    path: 'sales-center-stock-report',
    name: prop + '.sales_center_stock_report',
    meta: { auth: true },
    component: () => import('../pages/sales-center-stock-report/List.vue')
  },
  {
    path: 'sales-target-requests',
    name: prop + '.sales_target_requests',
    meta: { auth: true },
    component: () => import('../pages/sales-target-requests/List.vue')
  },
  {
    path: 'sales-target-approve-list',
    name: prop + '.sales_target_approve_list',
    meta: { auth: true },
    component: () => import('../pages/sales-target-approve-list/List.vue')
  },
  {
    path: 'monthly-sales-report',
    name: prop + '.monthly_sales_report',
    meta: { auth: true },
    component: () => import('../pages/monthly-sales-report/List.vue')
  },
  {
    path: 'demand-order-report',
    name: prop + '.demand_order_report',
    meta: { auth: true },
    component: () => import('../pages/demand-order-report/List.vue')
  },
  {
    path: 'delivery-report',
    name: prop + '.delivery_report',
    meta: { auth: true },
    component: () => import('../pages/delivery-report/List.vue')
  },
  {
    path: 'due-collection-report',
    name: prop + '.due_collection_report',
    meta: { auth: true },
    component: () => import('../pages/due-collection-report/List.vue')
  },
  {
    path: 'free-product-report',
    name: prop + '.free_product_report',
    meta: { auth: true },
    component: () => import('../pages/free-product-report/List.vue')
  },
  {
    path: 'dealer-retailer-ledger',
    name: prop + '.dealer_retailer_ledger',
    meta: { auth: true },
    component: () => import('../pages/dealer-retailer-ledger/List.vue')
  },
  {
    path: 'demand-order-view',
    name: prop + '.demand_order_view',
    meta: { auth: true },
    component: () => import('../pages/demand-order-view/List.vue')
  },
  {
    path: 'demand-order-details',
    name: prop + '.demand_order_details',
    meta: { auth: true },
    component: () => import('../pages/demand-order-view/DemandView.vue')
  },
  {
    path: 'delivery-order-payment',
    name: prop + '.delivery_order_payment',
    meta: { auth: true },
    component: () => import('../pages/payment/List.vue')
  },
  {
    path: 'return-product',
    name: prop + 'return_product',
    meta: { auth: true },
    component: () => import('../pages/return-product/List.vue')
  },
  {
    path: 'product-return-report',
    name: prop + 'product_return_report',
    meta: { auth: true },
    component: () => import('../pages/product-return-report/List.vue')
  },
  {
    path: 'sales-register',
    name: prop + '.sales_register',
    meta: { auth: true },
    component: () => import('../pages/sales-register/List.vue')
  },
  {
    path: 'sales-report',
    name: prop + '.sales_report',
    meta: { auth: true },
    component: () => import('../pages/sales-report/List.vue')
  }
]
const routes = [{
  path: '/production-service/sales-distribution-admin',
  name: 'production_service.sales_distribution_admin',
  component: () => import('@/layouts/ProductionLayout.vue'),
  meta: { auth: true },
  children: childRoutes('production_service.sales_distribution_admin')
}]

export default routes
